import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
    const { login, user } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user) {
            navigate(user.has_birth_info ? "/dashboard" : "/onboarding", { replace: true });
        }
    }, [user, navigate]);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email, password);
            toast.success("Welcome back, traveler.");
            navigate(u.has_birth_info ? "/dashboard" : "/onboarding");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    const googleLogin = () => {
        const redirectUrl = window.location.origin + "/auth/callback";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <>
            <Navbar />
            <main className="min-h-screen flex items-center justify-center px-6 pt-24">
                <div className="glass p-10 max-w-md w-full fade-in">
                    <p className="label-tracking text-gold text-center">Return to the stars</p>
                    <h1 className="font-serif text-4xl text-center mt-3">Welcome back</h1>

                    <form onSubmit={onSubmit} className="mt-8 space-y-5">
                        <div>
                            <label className="label-tracking">Email</label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full mt-2 px-4 py-3 rounded-xl bg-white/5 border border-white/10 focus:border-gold outline-none transition-colors"
                                data-testid="login-email"
                            />
                        </div>
                        <div>
                            <label className="label-tracking">Password</label>
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full mt-2 px-4 py-3 rounded-xl bg-white/5 border border-white/10 focus:border-gold outline-none transition-colors"
                                data-testid="login-password"
                            />
                        </div>
                        <button type="submit" disabled={loading} className="btn-gold-solid w-full" data-testid="login-submit">
                            {loading ? "Aligning..." : "Sign In"}
                        </button>
                    </form>

                    <div className="relative my-6">
                        <div className="absolute inset-0 flex items-center"><span className="w-full border-t border-white/10" /></div>
                        <span className="relative bg-[#0A0A1A] px-4 text-xs text-muted uppercase tracking-widest mx-auto block w-fit">or</span>
                    </div>

                    <button onClick={googleLogin} className="w-full btn-gold" data-testid="google-login">
                        Sign in with Google
                    </button>

                    <p className="text-center text-sm text-muted mt-8">
                        New to the cosmos?{" "}
                        <Link to="/register" className="text-gold hover:underline" data-testid="link-register">
                            Begin here
                        </Link>
                    </p>
                </div>
            </main>
        </>
    );
}
